// extracted by mini-css-extract-plugin
export default {"box":"VariationBoxIndicator_box__J-qHK","box-negative":"VariationBoxIndicator_box-negative__8DJQO","box-positive":"VariationBoxIndicator_box-positive__1ATbs"};